export enum EditorMode {
  BATCH_ANNOTATION = 'BATCH_ANNOTATION',
  BATCH_REVIEW = 'BATCH_REVIEW',
  BATCH_REVIEWEDIT = 'BATCH_REVIEWEDIT',
  FREEACCESS_ANNOTATION = 'FREEACCESS_ANNOTATION',
  FREEACCESS_EDIT = 'FREEACCESS_EDIT',
  FREEACCESS_REVIEW = 'FREEACCESS_REVIEW',
  FREEACCESS_REVIEWEDIT = 'FREEACCESS_REVIEWEDIT',
}
